module.exports = __webpack_public_path__ + "img/au.2caca53d.jpg";